import { useContext, useState, useEffect } from "react"
import { Box, Button, Typography } from "@mui/material"
import Grid from "@mui/material/Unstable_Grid2/Grid2"

import OneInput from '../../../../Components/OneInput/OneInput'
import { WebSocketContext } from "../../../../Providers/WebSocket/WebSocketContext"
import { showNotify } from '../../../../Utils/Utils'
import OneModal from "../../../../Components/OneModal/OneModal"
import { OneSwitch } from "../../../../Components/OneSwitch/OneSwitch"
import OneTextArea from "../../../../Components/OneTextArea/OneTextArea"

export const CadastroFechamento = ({ openCadastro, setOpenCadastro, idToEdit, setIdToEdit }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)

    const [initialData, setInitialData] = useState(null)
    const [loading, setLoading] = useState(true)
    const [formData, setFormData] = useState()

    const getDadosIniciais = (msg) => {
        if (msg.data.status) {
            setInitialData(msg.data.fechamento)
            setLoading(false)
        } else {
            showNotify(msg.message)
            setOpenCadastro(false)
        }
    }

    useEffect(() => {
        let stringId = idToEdit != null ? `${idToEdit}` : null
        if (stringId != null) {
            setLoading(true)
            addRoute("buscarFechamento", getDadosIniciais)
            sendWs("buscarFechamento", { id: idToEdit, listar: true })
        } else {
            setLoading(false)
        }
    }, [])

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            setIdToEdit(null)
            setOpenCadastro(false)
            showNotify("success", "Texto de fechamento salva com sucesso!")
            sendWs("buscarTodosFechamentos")
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("criarFechamento", responseSumbit)
    addRoute("editarFechamento", responseSumbit)

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const handleSubmit = (event) => {
        event.preventDefault()
        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            setOpenCadastro(false)
            return
        }
        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData

            sendWs("editarFechamento", { fechamento: data })
        } else {
            delete data.id
            sendWs("criarFechamento", { fechamento: data })
        }
    }

    return (
        <OneModal
            open={openCadastro}
            setOpen={setOpenCadastro}
            loading={loading}
            titleText="Texto de fechamento"
            FooterButtons={FooterButtons}
        >
            {!loading &&
            <form
                id="fechamento-form"
                onSubmit={handleSubmit}
            >
                <Grid
                    xs={12}
                    rowSpacing={0}
                    columnSpacing={1}
                    container
                    gap={0.5}
                    sx={{ maxWidth: '500px' }}
                >
                    <Grid container xs={12} rowGap={2} sx={{ alignItems: 'center' }}>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={5} sx={{ alignItems: 'center' }}>
                                <Grid xs={3} sm={4.7}>
                                    <Typography fontSize="13px" fontWeight='400' >Código: </Typography>
                                </Grid>
                                <Grid xs={9} sm={6}>
                                    <OneInput defaultValue={initialData?.numero} maxLength={4} onChange={handleChange} name={"numero"}/>
                                </Grid>
                            </Grid>
                            <Grid container xs={12} sm={3} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={4} lg={4}>
                                    <Typography fontSize="13px" fontWeight='400' >Ativo: </Typography>
                                </Grid>
                                <Grid xs={12} sm={4} lg={4}>
                                    <OneSwitch defaultChecked={initialData?.ativo} onChange={handleChange} name={"ativo"} />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid container xs={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} lg={2}>
                                    <Typography fontSize="13px" fontWeight='400' >*Titulo: </Typography>
                                </Grid>
                                <Grid xs>
                                    <OneInput defaultValue={initialData?.titulo} maxLength={50} onChange={handleChange} name={"titulo"}/>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid container xs={12} sm={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} sm={2} lg={2}>
                                    <Typography fontSize="13px" fontWeight='400' >*Descrição: </Typography>
                                </Grid>
                                <Grid xs={12} sm lg sx={{ height: '100px' }}>
                                    <OneTextArea
                                        defaultValue={initialData?.descricao}
                                        onChange={handleChange}
                                        autoFocus
                                        textarea="true"
                                        required
                                        name={"descricao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid container xs={12}>
                            <Grid xs={12} container>
                                <Grid xs={12} lg={2.5}>
                                    <Typography fontSize="13px" fontWeight='400' >Ex de variáveis: </Typography>
                                </Grid>
                                <Grid xs={12} lg={9.5}>
                                    <ListVariaveis/>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </form>
            }
        </OneModal>
    )
}

export const ListVariaveis = () => {
    const list = [
        {
            name: 'operador',
            desc: 'Nome do operador logado'
        },
        {
            name: 'condominio',
            desc: 'Nome do condominio do evento selecionado'
        },
        {
            name: 'auxiliar_evento',
            desc: 'Nome da auxiliar do evento selecionado'
        },
        {
            name: 'ramal',
            desc: 'Ramal do operador logado'
        }
    ]
    const cl = '{{'
    const cr = '}}'
    return (
        <Grid container xs={12} sx={{ display: 'flex', fontSize: '13px' }}>
            {list.map((el, i) => {
                return (
                    <Box component='div' key={i} sx={{ display: 'flex', marginRight: '10px' }}>
                        <Box component='span'>{cl}{el.name}{cr}</Box>
                    </Box>
                )
            })}
        </Grid>
    )
}
export const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="fechamento-form" type="submit">Salvar</Button>
        </Grid>
    )
}
